import MapHandler from '../mapHandler';

export default class CreateSegments extends MapHandler {
  constructor(options = {}) {
    super(options);
  }
}
